module.exports = __webpack_public_path__ + "static/img/case-zhengquan.53fb15e1.png";